import store from '@/store';
import {Action, Module} from 'vuex-module-decorators';
import {EntityStateAdapter} from './base.store';
import {take} from 'rxjs/operators';
import {UserApi} from '@/api/user.api';
import {UserModel} from '@/models/user.model';

export const featureKey = 'publicProfile';

// @ts-ignore
if (store.state.publicProfile) {
  store.unregisterModule(featureKey)
}

@Module({
  store,
  dynamic: true,
  name: featureKey,
  namespaced: true
})
export class PublicProfileStoreModule extends EntityStateAdapter<UserModel> {

  get publicProfile(): UserModel[] {
    return this._entities;
  }

  get loading(): boolean {
    return this._loading;
  }

  @Action({commit: 'insertMany', rawError: true})
  async fetchPublicProfile(slug: string): Promise<UserModel> {
    this.updateLoading(true);
    return await (new UserApi())
      .findBySlug(slug)
      .pipe(take(1))
      .toPromise();
  }
}
